import { z } from 'zod'
import { initContract } from '@ts-rest/core'
import { ErrorResponseSchema } from './general'
import { EnrichedOrder, UpdateOrderDeliveryInfoSchema } from '@repo/api-types'
import { OrderResponseDto } from '@lyka-pet-food/contracts'

const c = initContract()

export const orderContract = c.router(
  {
    getOrders: {
      method: 'GET',
      path: '/orders',
      responses: {
        200: c.type<{
          pastOrders: EnrichedOrder[]
          currentOrders: EnrichedOrder[]
          futureOrders: EnrichedOrder[]
          failedOrders: EnrichedOrder[]
          nextAvailableOrderDate: string | null
        }>(),
      },
    },
    getPastOrders: {
      method: 'GET',
      path: '/orders/past',
      responses: {
        200: c.type<EnrichedOrder[]>(),
      },
    },
    addOneOffExtra: {
      method: 'POST',
      path: '/order/:orderId/add-extra',
      pathParams: z.object({
        orderId: z.string(),
      }),
      body: z.object({
        subscriptionId: z.string(),
        productVariantId: z.string(),
        quantity: z.number(),
      }),
      responses: {
        200: c.type<{ order: OrderResponseDto }>(),
      },
    },
    updateOneOffExtra: {
      method: 'POST',
      path: '/order/:orderId/update-extra',
      pathParams: z.object({
        orderId: z.string(),
      }),
      body: z.object({
        subscriptionId: z.string(),
        orderLineItemId: z.string(),
        quantity: z.number(),
      }),
      responses: {
        200: c.type<{ order: OrderResponseDto }>(),
      },
    },
    deleteOneOffExtra: {
      method: 'POST',
      path: '/order/:orderId/delete-extra',
      pathParams: z.object({
        orderId: z.string(),
      }),
      body: z.object({
        subscriptionId: z.string(),
        orderLineItemId: z.string(),
      }),
      responses: {
        200: c.type<{ order: OrderResponseDto }>(),
      },
    },
    updateOrderDeliveryInfo: {
      method: 'POST',
      path: '/orders/:orderId/delivery-info',
      body: UpdateOrderDeliveryInfoSchema,
      pathParams: z.object({
        orderId: z.string(),
      }),
      responses: {
        200: z.object({
          orderId: z.string(),
        }),
      },
    },
  },
  {
    commonResponses: {
      400: ErrorResponseSchema,
      401: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema,
    },
  },
)
